import React from 'react';
import './index.css';
import { render } from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import {Router} from 'react-router-dom';
import { history } from './_helpers'
import routes from './routes';

render(
    <Router history={history}>
        {routes}
    </Router>,
    document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js